import '../../../../diagnosticReporting/DiagnosticStyles.css';

import React, {useState, useContext, useEffect} from 'react';
import {Form, Select, Row, Col, Divider, Checkbox, Table, Radio, Switch, Tooltip} from 'antd';
import {
    AGGREGATE_LEVELS,
    COMPARISON_TYPE,
    FB_MESSAGES,
    GRID_ENUMS,
    GridStyle
} from "../../../../diagnosticReporting/Styles";
import axios from "@common/axios";
import StudentTestResultDialog from "../../../../diagnosticReporting/StudentTestResultDialog";
import CircularLoader from "@common/CircularLoader";
import {BrandContext} from "@context/BrandContext";
import {UserContext} from "@context/UserContext";
import ClassQuestionViewDiagnosticV2 from "../../../../diagnosticReporting/ClassQuestionViewDiagnosticV2";
import GroupByAggregateViewV2 from "../../../../diagnosticReporting/GroupByAggregateViewV2";
import {getAggregateLevelVal} from "../../../../diagnosticReporting/Utils";
import ComparisonView from "../../../../diagnosticReporting/ComparisonView";
import TreeSelectFilter from "../../../../diagnosticReporting/TreeSelectFilter";
import StudentPerformanceView from "../../../../diagnosticReporting/StudentPerformanceView";
import ScoreVsTimeView from "../../../../diagnosticReporting/ScoreVsTimeView";
import GrowthVsAttainment from "../../../../diagnosticReporting/GrowthVsAttainment";
import Card from "@common/Card";
import CollapsibleCard from "@common/CollapsibleCard";
import Button, {BUTTON_SIZE} from "@common/Button";
import HelpIcon from "@mui/icons-material/Help";
import PeopleIcon from "@mui/icons-material/People";
import ClassIcon from "@common/icons/ClassIcon";
import MuiTooltip from "@common/Tooltip";

const { Option } = Select;

export const GROWTH_FILTER  = {
        ALL: {val: 1, description: 'All'},
        WITH_NEGATIVE_GROWTH: {val: 2, description: 'With negative growth'},
        WITH_POSITIVE_GROWTH: {val: 3, description: 'With positive growth'},
        ABOVE_AVERAGE_GROWTH: {val: 4, description: 'Above average growth'},
        BELOW_AVERAGE_GROWTH: {val: 5, description: 'Below average growth'},
        ABOVE_AVERAGE_SCORE: {val: 6, description: 'Above average score'},
        BELOW_AVERAGE_SCORE: {val: 7, description: 'Below average score'}
    },
    TIME_FILTER = {
        ALL: {val: 1, description: 'All'},
        WITH_INCREASED_SCORE: {val: 2, description: 'With increased score'},
        WITH_DECREASED_SCORE: {val: 3, description: 'With decreased score'},
        ABOVE_AVERAGE_TIME_TAKEN: {val: 4, description: 'Above average time taken'},
        BELOW_AVERAGE_TIME_TAKEN: {val: 5, description: 'Below average time taken'},
        ABOVE_AVERAGE_SCORE: {val: 6, description: 'Above average score'},
        BELOW_AVERAGE_SCORE: {val: 7, description: 'Below average score'},
        WITH_INCREASED_TIME_TAKEN: {val: 8, description: 'With increased time taken'},
        WITH_DECREASED_TIME_TAKEN: {val: 9, description: 'With decreased time taken'}
    },
    TEST_GROUP_TEST_TYPES = {
        POST_TEST: 'postTest',
        PRE_TEST: 'preTest'
    },
    LOCATION_AGGREGATE = {
        SELECTION: {val: 1, description: 'Class'},
        // CLASS: {val: 2, description: 'Class'},
        SCHOOL: {val: 2, description: 'School'},
        // STATE: {val: 3, description: 'With positive growth'}
    },
    PERFORMANCE_ORDER  = {
        ALPHABETICAL: {val: 'ALPHABETICAL', order: 'name', description: 'Alphabetical', direction: GRID_ENUMS.ASC},
        PRE_TEST_LOWEST: {val: 'PRE_TEST_LOWEST', order: 'performancePre', description: 'Lowest performance in pre/mid-test', direction: GRID_ENUMS.ASC},
        PRE_TEST_HIGHEST: {val: 'PRE_TEST_HIGHEST', order: 'performancePre', description: 'Highest performance in pre/mid-test', direction: GRID_ENUMS.DESC},
        POST_TEST_LOWEST: {val: 'POST_TEST_LOWEST', order: 'performancePost', description: 'Lowest performance in post-test', direction: GRID_ENUMS.ASC},
        POST_TEST_HIGHEST: {val: 'POST_TEST_HIGHEST', order: 'performancePost', description: 'Highest performance in post-test', direction: GRID_ENUMS.DESC},
        PRE_TEST_DISTANCE_FROM_AVERAGE: {val: 'PRE_TEST_DISTANCE_FROM_AVERAGE', order: 'distanceFromAveragePre', description: 'Distance from average in pre/mid-test', direction: GRID_ENUMS.ASC},
        POST_TEST_DISTANCE_FROM_AVERAGE: {val: 'POST_TEST_DISTANCE_FROM_AVERAGE', order: 'distanceFromAveragePost', description: 'Distance from average in post-test', direction: GRID_ENUMS.ASC},
        GREATEST_GROWTH: {val: 'GREATEST_GROWTH', order: 'growth', description: 'Greatest growth', direction: GRID_ENUMS.DESC},
        LEAST_GROWTH: {val: 'LEAST_GROWTH', order: 'growth', description: 'Least growth', direction: GRID_ENUMS.ASC}
    };


const STANDARD_REPORTS = {
        CLASS_QUESTION_VIEW: {val: 1, description: 'Results by question', postTestRequired: false, testResultSkillsRequired: false},
        GROUP_BY_VIEW: {val: 2, description: 'Results by skills', postTestRequired: false, testResultSkillsRequired: false},
        COMPARISON_VIEW: {val: 3, description: 'Test comparison', postTestRequired: false, testResultSkillsRequired: false},
        STUDENT_PERFORMANCE_VIEW: {val: 4, description: 'Performance by student', postTestRequired: true, testResultSkillsRequired: true},
        SCORE_VS_TIME_VIEW: {val: 5, description: 'Score vs. time taken', postTestRequired: false, testResultSkillsRequired: false},
        GROWTH_VS_ATTAINMENT_VIEW: {val: 6, description: 'Growth vs. attainment', postTestRequired: true, testResultSkillsRequired: false}
    },
    VAL_TO_REPORT = {
        '1':STANDARD_REPORTS.CLASS_QUESTION_VIEW,
        '2':STANDARD_REPORTS.GROUP_BY_VIEW,
        '3':STANDARD_REPORTS.COMPARISON_VIEW,
        '4':STANDARD_REPORTS.STUDENT_PERFORMANCE_VIEW,
        '5':STANDARD_REPORTS.SCORE_VS_TIME_VIEW,
        '6':STANDARD_REPORTS.GROWTH_VS_ATTAINMENT_VIEW,
    },

    AGGREGATE_VIEW_TOOLTIP = (<div><p>This will allow you to see student performance at various textbook/curriculum levels.</p>
        {/*<p>Use the column toggle buttons to collapse the view.</p>*/}
    </div>);

let testInfo = {};

const TestGroupReports = () => {

    const brandConfig = useContext(BrandContext),
        {user, setUser, menuPosition} = useContext(UserContext),
        [initialReportGenerated, setInitialReportGenerated] = useState(false),
        [testGroupTestAssignmentsMap,setTestGroupTestAssignmentsMap] = useState({}),
        [refineDisabled,setRefineDisabled] = useState(true),
        [refineExpanded,setRefineExpanded] = useState(null),
        [isLoading, setLoading] = useState(false),
        [isTableLoading, setTableLoading] = useState(false),
        [feedbackMessage, setFeedbackMessage] = useState(undefined),
        [warningFeedbackMessage, setWarningFeedbackMessage] = useState(undefined),
        [contentType, setContentType] =  useState(GRID_ENUMS.TEXT),
        [students, setStudents] = useState([]),
        [studentIds, setStudentIds] = useState([]),
        [testGroupData, setTestGroupData] = useState([]),
        [initialStudentIds, setInitialStudentIds] = useState([]),
        [classes, setClasses] = useState([]),
        [classIds, setClassIds] = useState([]),
        [initialClassIds, setInitialClassIds] = useState([]),
        [classMap, setClassMap] = useState({}),
        [studentMap, setStudentMap] = useState({}),
        [className, setClassName] = useState(user.classId ? user.classes[user.classId] : null),
        [reportForm] = Form.useForm(),
        [showTrendLines,setShowTrendLines] = useState(true),
        [showGrowthLine,setShowGrowthLine] = useState(true),
        [showAverageScoreLine,setShowAverageScoreLine] = useState(true),
        [showAverageLine,setShowAverageLine] = useState(true),
        [showAverageTimeTakenLine,setAverageTimeTakenLine] = useState(true),
        [showAverageScoreTimeLine,setAverageScoreTimeLine] = useState(true),
        [comparisonContentTypeVal, setComparisonContentTypeVal] =  useState(COMPARISON_TYPE.TEXT.val),
        [textValues, setTextValues] = useState([]),
        [curriculumValues, setCurriculumValues] = useState([]),
        [classAverageTracker, setClassAverageTracker] = useState({}),
        [schoolAverageTracker, setSchoolAverageTracker] = useState({}),
        [selectedReportType, setSelectedReportType] = useState(STANDARD_REPORTS.CLASS_QUESTION_VIEW),
        [selectedReportTypeTemp, setSelectedReportTypeTemp] = useState(STANDARD_REPORTS.CLASS_QUESTION_VIEW),
        [selectedAggregateLevel, setSelectedAggregateLevel] = useState(AGGREGATE_LEVELS.SKILL),
        [aggregateHeaderAmount, setAggregateHeaderAmount] = useState(getAggregateLevelVal(AGGREGATE_LEVELS.SKILL)),
        [reportTitle, setReportTitle] = useState(''),
        [testAssignmentData, setTestAssignmentData] = useState([]),
        [testAssignmentResultsData, setTestAssignmentResultsData] = useState(undefined),
        [dataHasResults, setDataHasResults] = useState(false),
        [studentTestAssignmentsMap, setStudentTestAssignmentsMap] = useState({}),
        [initialTestAssignmentData, setInitialTestAssignmentData] = useState([]),
        [studentColOrder, setStudentColOrder] = useState(GRID_ENUMS.NAME_ASC),
        [studentGrowthFilter, setStudentGrowthFilter] = useState(GROWTH_FILTER.ALL),
        [studentTimeFilter, setStudentTimeFilter] = useState(TIME_FILTER.ALL),
        [classForm] = Form.useForm(),
        [testAssignments, setTestAssignments] = useState([]),
        [testGroups, setTestGroups] = useState([]),
        [testId, setTestId] = useState(null),
        [testAssignmentIds, setTestAssignmentIds] = useState([]),
        [userTestAssignmentIds, setUserTestAssignmentIds] = useState([]),
        [tempTestAssignmentIds, setTempTestAssignmentIds] = useState([]),
        [testGroupName, setTestGroupName] = useState(''),
        [testGroupId, setTestGroupId] = useState(null),
        [headerHeightOffset, setHeaderHeightOffset] = useState(0),
        [selectedDifficultyIds, setSelectedDifficultyIds] = useState([]),
        [selectedTestIds, setSelectedTestIds] = useState([]),
        [studentId, setStudentId] = useState(),
        [triggerStandardGenerate, setTriggerStandardGenerate] = useState(null),
        [selectedRowKeys, setSelectedRowKeys] = useState([]),
        [lastRecordKey, setLastRecordKey] = useState(-1),
        [studentTestResultDialogOpen, setStudentTestResultDialogOpen] = useState(false),
        [questionCount, setQuestionCount] = useState(),
        [performanceOrderBy, setPerformanceOrderBy] = useState(PERFORMANCE_ORDER.ALPHABETICAL),
        [timeTakenLineAggregate, setTimeTakenLineAggregate] = useState(null),
        [growthLineAggregate, setGrowthLineAggregate] = useState(null),
        [averageScoreLineGrowthReport, setAverageScoreLineGrowthReport] = useState(null),
        [averageScoreLineTimeReport, setAverageScoreLineTimeReport] = useState(null),
        [timeTakenTypeSelected, setTimeTakenTypeSelected] = useState(LOCATION_AGGREGATE.SELECTION),
        [growthTypeSelected, setGrowthTypeSelected] = useState(LOCATION_AGGREGATE.SELECTION),
        [averageScoreTypeSelected, setAverageScoreTypeSelected] = useState(LOCATION_AGGREGATE.SELECTION),
        [averageScoreTypeGrowthSelected, setAverageScoreTypeGrowthSelected] = useState(LOCATION_AGGREGATE.SELECTION),
        initialDifficultyIds = brandConfig.diagnosticTestLevels,
        teacherClassIds = user.classes.map((clazz) => {
            return clazz.classId;
        });

    const handleCloseStudentTestsDialog = () => {
        setStudentTestResultDialogOpen(false);
        setStudentId(null);
    }

    const openStudentTestsDialog = (locStudentId) => {
        if (!locStudentId) {
            return;
        }

        let locTestAssignmentIds = [];
        if (studentTestAssignmentsMap[locStudentId]) {
            for (const [testId, testAssignmentId] of Object.entries(studentTestAssignmentsMap[locStudentId])) {
                locTestAssignmentIds.push(testAssignmentId);
            }
        }
        setStudentId(locStudentId);
        setUserTestAssignmentIds(locTestAssignmentIds);
        setStudentTestResultDialogOpen(true);
    }

    useEffect(() => {
        showCascadingFeedbackMessage();
    }, [students, studentIds]);

    useEffect(()=>{
        if(testAssignmentResultsData !== undefined){
            setRefineDisabled(testAssignmentResultsData.length === 0);
        }
    },[testAssignmentResultsData]);

    const toggleTrendLines = value =>{
        setShowTrendLines(value);
    }

    const toggleGrowthLine = value =>{
        setShowGrowthLine(value);
    }

    const toggleScoreLine = value =>{
        setShowAverageScoreLine(value);
    }

    const toggleAverageLine = value =>{
        setShowAverageLine(value);
    }

    const toggleAverageTimeTakenLine = value =>{
        setAverageTimeTakenLine(value);
    }

    const toggleAverageScoreTimeLine = value =>{
        setAverageScoreTimeLine(value);
    }

    useEffect(()=>{
        setLoading(true);
        axios.get('/web/ui/test/loadTestGroupsForReports')
            .then(response => {
                if(response.data) {
                    setTestGroups(response.data);
                    setTestGroupData(modifyTestGroupDataForTable(response.data));
                    // setTestGroupData(response.data);
                }
                setLoading(false);
                // setMainLoading(false);
            }).catch((error) => {
            setLoading(false);
            // setMainLoading(false);
            console.error('Error loading test groups: ', error);
        });
    }, []);

    useEffect(() => {
        if (classIds.length > 0) {
            let tempStudents = [];
            classIds.forEach((classId) => {
                classMap[classId].forEach((studentId) => {
                    if (!tempStudents.includes(studentMap[studentId])) {
                        tempStudents = [...tempStudents, studentMap[studentId]];
                    }
                })
            });

            let tempStudentIds = tempStudents.map((student) => {
                return student.userId;
            });
            setStudents(tempStudents);
            setStudentIds(tempStudentIds);
            setInitialStudentIds(tempStudentIds);
            reportForm.setFieldsValue({['studentIds']: tempStudentIds});
        } else {
            clearStudentSelect();
        }
        showCascadingFeedbackMessage();
    }, [classIds]);

    const clearStudentSelect = () => {
        reportForm.setFieldsValue({['studentIds']: []});
        setStudentIds([]);
        setStudents([]);
        setInitialStudentIds([]);
        setStudentIds([]);
    }

    const handleClassClear = () => {
        clearStudentSelect();
    }

    const handleStudentChange = value=>{
        setStudentIds(value);
    }

    const handleSelectAllStudentsChange = event => {
        if (event.target.checked) {
            setStudentIds(initialStudentIds);
            reportForm.setFieldsValue({['studentIds']: initialStudentIds});
        } else {
            reportForm.setFieldsValue({['studentIds']: []});
            setStudentIds([]);
        }
    }

    const clearClassSelect = () => {
        reportForm.setFieldsValue({['classIds']: []});
        setClassIds([]);
    }

    const handleClassChange = value => {
        setClassIds(value);
    }
    // const timeTakenClassChange = value => {
    //     if(value !== undefined){
    //         if(classAverageTracker.hasOwnProperty(value+'') && classAverageTracker[value+''].hasOwnProperty('timeTaken')){
    //             setTimeTakenLineAggregate(classAverageTracker[value+'']['timeTaken']);
    //         }else{
    //             const updateTracker =  {...classAverageTracker};
    //             getAverageClassTimeTaken(value,(classTimeTakenAverage)=>{
    //                 setTimeTakenLineAggregate(classTimeTakenAverage);
    //                if(!updateTracker.hasOwnProperty(value+'')){
    //                    updateTracker[value+''] = {timeTaken:classTimeTakenAverage};
    //                }else{
    //                    updateTracker[value+''].timeTaken = classTimeTakenAverage;
    //                }
    //                setTimeTakenLineAggregate(classTimeTakenAverage);
    //                setClassAverageTracker(updateTracker);
    //             });
    //
    //         }
    //     }
    // }

    // const averageScoreTimeClassChange = (value,setFunction) => {
    //     if(value !== undefined){
    //         if(classAverageTracker.hasOwnProperty(value+'') && classAverageTracker[value+''].hasOwnProperty('averageScore')){
    //             setFunction(classAverageTracker[value+''].averageScore);
    //         }else{
    //             const updateTracker =  {...classAverageTracker};
    //             getAverageClassScore(value,(averageScore)=>{
    //                 setAverageScoreLineTimeReport(averageScore);
    //                 if(!updateTracker.hasOwnProperty(value+'')){
    //                     updateTracker[value+''] = {averageScore:averageScore};
    //                 }else{
    //                     updateTracker[value+''].averageScore = averageScore;
    //                 }
    //                 setFunction(averageScore);
    //                 setClassAverageTracker(updateTracker);
    //             });
    //
    //         }
    //     }
    // }

    // const averageScoreGrowthClassChange = (value) => {
    //     if(value !== undefined){
    //         if(classAverageTracker.hasOwnProperty(value+'') && classAverageTracker[value+''].hasOwnProperty('averageGrowth')){
    //             setGrowthLineAggregate(classAverageTracker[value+''].averageGrowth);
    //         }else{
    //             const updateTracker =  {...classAverageTracker};
    //             getAverageClassGrowth(value,(averageGrowth)=>{
    //                 // console.log('averageGrowth: ',averageGrowth);
    //                 setAverageScoreLineTimeReport(averageGrowth);
    //                 if(!updateTracker.hasOwnProperty(value+'')){
    //                     updateTracker[value+''] = {averageGrowth:averageGrowth};
    //                 }else{
    //                     updateTracker[value+''].averageGrowth = averageGrowth;
    //                 }
    //                 setGrowthLineAggregate(averageGrowth);
    //                 setClassAverageTracker(updateTracker);
    //             });
    //         }
    //     }
    // }


    const handleSelectAllClassesChange = event => {
        if (event.target.checked) {
            setClassIds(initialClassIds);
            reportForm.setFieldsValue({['classIds']: initialClassIds});
        } else {
            clearClassSelect();
        }
    }

    // const handleSelectAllClassesAverageTimeChange = event => {
    //     if (event.target.checked) {
    //         setClassIds(initialClassIds);
    //         reportForm.setFieldsValue({['classIds']: initialClassIds});
    //     } else {
    //         clearClassSelect();
    //     }
    // }

    const handleDifficultyChange = value => {
        // setLoading(true);
        setSelectedDifficultyIds(value.sort());
    }

    const handleStudentColOrderByChange = value => {
        // setLoading(true);
        setStudentColOrder(value);
    }

    const handleStudentGrowthOrderByChange = value => {
        // setLoading(true);
        setStudentGrowthFilter(value);
    }

    const handleStudentTimeOrderByChange = value => {
        // setLoading(true);
        setStudentTimeFilter(value);
    }

    const handlePerformanceOrderByChange = value => {
        // setLoading(true);
        setPerformanceOrderBy(PERFORMANCE_ORDER[value]);
    }

    const modifyTestGroupDataForTable = (data)=>{
        const modifiedData = [];
        data.forEach((row)=>{
            const updateRow = {...row};
            updateRow.enabled = row.totalTestsAssigned > 0;
            updateRow.key = String(updateRow.testGroupId);
            modifiedData.push(updateRow);
        });
        return modifiedData;
    }

    const handleReportChange = value =>{
        setSelectedReportTypeTemp(VAL_TO_REPORT[value]);
    }

    const handleTestAssignments = value =>{
        setTempTestAssignmentIds(value);
    }

    useEffect(()=>{
        if(initialTestAssignmentData.length > 0){
            setTestAssignmentData([...initialTestAssignmentData]);
        }
    },[selectedReportTypeTemp]);

    const filterTestsAndExams = (data) => {
        return data;
    }

    const generateStandardReport = ()=> {
        setSelectedReportType(selectedReportTypeTemp);
        setDataHasResults(false);
        const arr1 = JSON.stringify([...testAssignmentIds].sort()),
            arr2 = JSON.stringify([...tempTestAssignmentIds].sort());
        if(testAssignmentIds.length > 0 && testAssignmentIds.length === tempTestAssignmentIds.length && arr1 === arr2){
            setTriggerStandardGenerate(new Date().getTime());
        }else{
            setTestAssignmentIds(tempTestAssignmentIds);
        }
    }

    useEffect(()=>{
        if(testAssignmentIds.length > 0){
            setTriggerStandardGenerate(new Date().getTime());
        }
    },[testAssignmentIds]);

    const showCascadingFeedbackMessage = ()=>{
        let messageShown = true;
        if(selectedRowKeys.length === 0){
            setFeedbackMessage(FB_MESSAGES.SELECT_STANDARD_TEST_GROUP_MESSAGE);
        }else if (testAssignments.length === 0) {
            setFeedbackMessage(FB_MESSAGES.NO_TEST_ASSIGNMENTS_FOR_TEST_FAMILY_MESSAGE);
        }else if (!initialReportGenerated) {
            setFeedbackMessage(FB_MESSAGES.GENERATE_REPORT_MESSAGE);
        }else if (tempTestAssignmentIds.length === 0) {
            setFeedbackMessage(FB_MESSAGES.SELECT_TEST_ASSIGNMENTS_MESSAGE);
        }else if (classIds.length === 0) {
            setFeedbackMessage(FB_MESSAGES.SELECT_CLASS_TEST_MESSAGE);
        }else if (testAssignmentResultsData !== undefined && !dataHasResults) {
            setFeedbackMessage(FB_MESSAGES.NO_STUDENT_RESULTS_DATA_NO_TEST);
        }else if(studentIds.length === 0) {
            setFeedbackMessage(FB_MESSAGES.SELECT_STUDENT_TEST_GROUP_MESSAGE);
        }else{
            setFeedbackMessage(undefined);
            messageShown = false;
        }
        return messageShown;
    }

    useEffect(()=>{
        if(testAssignments.length > 0){
            const standardData = [];
            testAssignments.forEach( tA =>{
                standardData.push({
                    name: tA.testName,
                    key: tA.testAssignmentId,
                    classes:tA.classes,
                    testId: tA.testId,
                    assignedBy: tA.assignedBy,
                    assignedDate: user.dateFormat.format(new Date(tA.assignedDate)),
                    startDate: user.dateFormat.format(new Date(tA.startDate)),
                    endDate: user.dateFormat.format(new Date(tA.endDate)),
                    expiry: tA.expired ? 'expired' : tA.timeToExpiry,
                    isExam: tA.exam
                });
            });
            const updateTestAssignmentData = [],
                initialData = [];
            for(let i = 0; i < standardData.length; i++){
                let dataRow = standardData[i];
                if(dataRow.testId){
                    dataRow.questions = testInfo[dataRow.testId+''].questions;
                    dataRow.createdBy = testInfo[dataRow.testId+''].createdBy;
                    updateTestAssignmentData.push(filterTestsAndExams(standardData));
                    initialData.push(standardData);
                }
            }
            setTestAssignmentData(updateTestAssignmentData);
            setInitialTestAssignmentData(initialData);
            setTableLoading(false);
        }else{
            setTestAssignmentData([]);
            setInitialTestAssignmentData([]);
            setTableLoading(false);
        }

        setTempTestAssignmentIds(testAssignments.map(assign =>{return assign.testAssignmentId}));
        setSelectedTestIds(testAssignments.map(assign =>{return assign.testId}));
    },[testAssignments]);


    useEffect(()=>{
        if(testAssignmentData.length > 0){
            testAssignmentData.forEach( rowData =>{
                rowData.enabled = students.length > 0;
            });
        }
    },[testAssignmentData]);

    useEffect( ()=>{
        if(selectedRowKeys.length > 0){
            const key = String(selectedRowKeys[0]);
            if(testGroupTestAssignmentsMap.hasOwnProperty(key)){
                setTestAssignments(testGroupTestAssignmentsMap[key]);
                setTableLoading(false);
            }else{
                const testAssignTestGroup = {...testGroupTestAssignmentsMap};
                axios.post('/web/ui/test/searchTeacherTestAssignments', {
                    testGroupId: key,
                    testPurpose: 'DIAGNOSTIC_TEST',
                    populateWithStudentIds: true,
                    teacherId: user.userId,
                    testAssignerSearchType: 'CLASSES'
                }).then(response => {
                    const updateTestAssignments = response.data;
                    testAssignTestGroup[key] = response.data;

                    let testIds = [...new Set(updateTestAssignments.map(({testId})=>testId))];
                    const promises = [];
                    testIds.forEach((testId)=>{
                        if(!testInfo.hasOwnProperty(testId+'')){
                            promises.push(getTestInfo(testId));
                        }
                    });

                    Promise.all(promises).then(()=>{
                        setTestGroupTestAssignmentsMap(testAssignTestGroup);
                        setTestAssignments(updateTestAssignments);
                        setTableLoading(false);
                    })

                }).catch((error) => {
                    displayToastMessage('Error finding test assignments', error.data.message, 'error', undefined, 10000);
                    setTableLoading(false);
                });
            }
        }else{
            setTableLoading(false);
        }
    },[selectedRowKeys]);

    const getTestInfo = (testId)=>{
        return new Promise((resolve, reject)=>{axios.get('/web/ui/test/test',{params:{ testId: testId }}).then(response =>{
            if(response.data){
                testInfo[testId+''] = {questions:response.data.questionCount, createdBy: response.data.ownedBy};
            }
            resolve();
        }).catch(error =>{
            reject(new Error('error'));
            console.error('Error retrieving test: ', error);
        });
        })
    }

    const standardTestGroupColumns = [
        {
            title: 'Name',
            dataIndex: 'testGroupName',
            // width: 240,
            ellipsis: true
        },
        {
            title: 'Total tests',
            dataIndex: 'totalTests',
            // width: 84,
            // align:'center'
        },
        {
            title: 'Tests assigned',
            dataIndex: 'totalTestsAssigned',
            // width: 84,
            // align:'center'
        },
        {
            title: 'Total questions',
            dataIndex: 'totalQuestionsInGroup',
            // width: 84,
            // align:'center'
        },
        {
            title: 'Pre/mid tests',
            dataIndex: 'preTotalTests',
            // width: 84,
            // align:'center'
        },
        {
            title: 'Post test generated',
            dataIndex: 'postTestGenerated',
            render: (value) => {
                return <>
                    <div>{value ? 'yes':'no'}</div>
                </>}
            // width: 84,
            // align:'center'
        }
    ];

    useEffect(()=>{
        if(testAssignmentIds.length > 0){
            setLoading(true);
            axios.get('/web/ui/test/loadTestAssignmentsReportResults', {params: {testAssignmentIds: testAssignmentIds.toString(), testResultSkillsRequired: selectedReportType.testResultSkillsRequired, reportName: selectedReportType.description}})
                .then(response => {
                    let hasResults = false,
                        tempPostTestResults = false,
                        studentAssignmentIdsMap = {},
                        tempStudentMap = {},
                        classStudentMap = {},
                        tempClasses = [];
                    const updateData = [...response.data];
                    if (updateData) {
                        updateData.forEach((data) => {
                            if (data.testPurpose === 'DIAGNOSTIC_POST_TEST') tempPostTestResults = true;
                            data.classes.forEach((clazz) => {
                                if (!classStudentMap[clazz.classId]) {
                                    classStudentMap[clazz.classId] = [];
                                    tempClasses.push(clazz);
                                }
                            });

                            for (const [studentKey, testMapValue] of Object.entries(data.studentTestAssignmentMap)) {
                                if (studentAssignmentIdsMap[studentKey]) {
                                    for (const [testKey, assignmentValue] of Object.entries(studentAssignmentIdsMap[studentKey])) {
                                        if (testMapValue.hasOwnProperty(testKey)) {
                                            testMapValue[testKey] = [...testMapValue[testKey], ...assignmentValue];
                                        }
                                    }

                                    studentAssignmentIdsMap[studentKey] = {...studentAssignmentIdsMap[studentKey], ...testMapValue};
                                } else {
                                    studentAssignmentIdsMap[studentKey] = testMapValue;
                                }
                            }
                            data.testResultBeans.forEach((testResultBean) => {
                                if (!tempStudentMap.hasOwnProperty(testResultBean.userId)) {
                                    tempStudentMap[testResultBean.userId] = {
                                        userId: testResultBean.userId,
                                        lastName: testResultBean.lastName,
                                        firstName: testResultBean.firstName
                                    }
                                }

                                testResultBean.classIds.forEach((id) => {
                                    if (classStudentMap[id] && !classStudentMap[id].includes(testResultBean.userId)) {
                                        classStudentMap[id] = [...classStudentMap[id], testResultBean.userId];
                                    }
                                });
                            });
                        });

                        let tempClassIds = tempClasses.map((clazz) => {
                            return clazz.classId;
                        });
                        setClasses(tempClasses);
                        setClassMap(classStudentMap);
                        setStudentMap(tempStudentMap);
                        setInitialClassIds(tempClassIds);
                        setClassIds(tempClassIds);
                        reportForm.setFieldsValue({['classIds']: tempClassIds});

                        hasResults = selectedReportType.testResultSkillsRequired ? updateData.some(elem => elem.hasSkillResults) : updateData.some(elem => elem.hasQuestionResults);

                        setQuestionCount(updateData.questionCount);
                        setStudentTestAssignmentsMap(studentAssignmentIdsMap);
                        setTestAssignmentResultsData(updateData);

                        setDataHasResults(hasResults);
                        if (hasResults) {
                            setRefineExpanded(true);
                            setFeedbackMessage(undefined);
                        } else {
                            setFeedbackMessage(FB_MESSAGES.NO_STUDENT_RESULTS_DATA_NO_TEST);
                        }
                        if (!initialReportGenerated) {
                            setInitialReportGenerated(true);
                        }
                        setReportTitle(selectedReportTypeTemp.description + ' &#8212; ' + testGroupName);
                    }
                    setLoading(false);
                }).catch(error => {
                console.error('Error loading test assignment results: ', error);
                setLoading(false);
                setTestAssignmentResultsData(undefined);
                setFeedbackMessage('Error loading results');
            });
        }
    },[triggerStandardGenerate]);

    const handleAggregateLevelChange = value =>{
        setSelectedAggregateLevel(value);
        setAggregateHeaderAmount(getAggregateLevelVal(value));
    }

    const rowSelection = {
        selectedRowKeys,
        type:'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            const record = selectedRows[0];
            onRowClick(record);
        },
        getCheckboxProps: (record) => ({
            disabled: (record.totalTestsAssigned === 0)
        }),
    };

    const onRowClick = (record)=>{
        if (record.totalTestsAssigned > 0) {
            setTableLoading(true);
            if (record.key === lastRecordKey && selectedRowKeys.length > 0) {
                setSelectedRowKeys([]);
                setTestAssignments([]);
                setTestGroupName('');
                setTestGroupId(null);
            } else {
                setSelectedRowKeys([record.key]);
                setTestGroupId(record.key);
                testGroups.forEach(group => {
                    if (record.key === String(group.testGroupId)) {
                        setTestGroupName(group.testGroupName);
                    }
                })
            }
            setLastRecordKey(record.key);
        }
    }

    useEffect(()=>{
        classForm.setFieldValue('testAssignmentIds',tempTestAssignmentIds);
        showCascadingFeedbackMessage();
    },[tempTestAssignmentIds])

    useEffect(()=>{
        showCascadingFeedbackMessage();
    },[testId,selectedRowKeys]);

    const handleContentTypeChange = e =>{
        setContentType(e.target.value);
    }

    const handleTreeSelectContentFilterChange = e =>{
        setComparisonContentTypeVal(e.target.value);
    }

    const handleTimeTakenAggregateChange = (val)=>{
        if(val === LOCATION_AGGREGATE.SELECTION.val){
            setTimeTakenLineAggregate(null);
        }else if(val === LOCATION_AGGREGATE.SCHOOL.val){
            getAverageSchoolTimeTaken();
        }
        // setShowTimeTakenClasses(val === LOCATION_AGGREGATE.CLASS.val);
        setTimeTakenTypeSelected(val);
    }

    const handleAverageScoreLineTime = (val) =>{
        if(val === LOCATION_AGGREGATE.SELECTION.val){
            setAverageScoreLineTimeReport(null);
        }else if(val === LOCATION_AGGREGATE.SCHOOL.val){
            getAverageSchoolScore(setAverageScoreLineTimeReport);
        }
        // setShowScoreTimeClasses(val === LOCATION_AGGREGATE.CLASS.val);
        setAverageScoreTypeSelected(val)
    }

    const handleAverageScoreLineGrowth = (val) =>{
        if(val === LOCATION_AGGREGATE.SELECTION.val){
            setAverageScoreLineGrowthReport(null);
        }else if(val === LOCATION_AGGREGATE.SCHOOL.val){
            getAverageSchoolScore(setAverageScoreLineGrowthReport);
        }
        // setShowScoreGrowthClasses(val === LOCATION_AGGREGATE.CLASS.val);
        setAverageScoreTypeGrowthSelected(val);
    }

    const handleAverageGrowthLine = (val) =>{
        if(val === LOCATION_AGGREGATE.SELECTION.val){
            setGrowthLineAggregate(null);
        }else if(val === LOCATION_AGGREGATE.SCHOOL.val){
            getAverageSchoolGrowth();
        }
        // setShowGrowthLineClasses(val === LOCATION_AGGREGATE.CLASS.val);
        setGrowthTypeSelected(val);
    }

    const getAverageSchoolTimeTaken = ()=>{
        const schoolId = user.schoolId;
        if(schoolId !== undefined){
            if(schoolAverageTracker.hasOwnProperty(schoolId+'') && schoolAverageTracker[schoolId+''].hasOwnProperty('averageScore')){
                setTimeTakenLineAggregate(schoolAverageTracker[schoolId+''].averageScore);
            }else{
                axios.post('/web/ui/test/getSchoolAverageTimeTaken', [], {params: {testGroupId:testGroupId
                        // , schoolId: schoolId
                }})
                    .then(response => {
                        const updateTracker =  {...schoolAverageTracker};
                        const averageTimeTaken = response.data;
                        setTimeTakenLineAggregate(averageTimeTaken)
                        updateTracker[schoolId+''] = {timeTaken:averageTimeTaken};
                        if(!updateTracker[schoolId+''].hasOwnProperty(schoolId+'')){
                            updateTracker[schoolId+''] = {timeTaken:averageTimeTaken};
                        }else{
                            updateTracker[schoolId+''].timeTaken = averageTimeTaken;
                        }
                        setSchoolAverageTracker(updateTracker);
                    }).catch((error) => {
                    console.error('Error loading school average score: ', error);
                });

            }
        }
    }

    // const getAverageClassTimeTaken = (classId, callback)=>{
    //     if(testGroupId !== null){
    //         axios.post('/web/ui/test/getClassAverageTimeTaken', [], {params: {testGroupId:testGroupId, classId: classId}})
    //             .then(response => {
    //                 callback(response.data);
    //             }).catch((error) => {
    //             console.error('Error loading class time taken: ', error);
    //         });
    //     }
    // }

    const getAverageSchoolScore = (setValueFunction)=>{
        const schoolId = user.schoolId;
        if(schoolId !== undefined){
            if(schoolAverageTracker.hasOwnProperty(schoolId+'') && schoolAverageTracker[schoolId+''].hasOwnProperty('averageScore')){
                setValueFunction(schoolAverageTracker[schoolId+''].averageScore);
            }else{
                axios.post('/web/ui/test/getSchoolAverageScore', [], {params: {testGroupId:testGroupId
                        // , schoolId: schoolId
                }})
                    .then(response => {
                        const updateTracker =  {...schoolAverageTracker};
                        const averageScore = response.data;
                        updateTracker[schoolId+''] = {averageScore:averageScore};
                        if(!updateTracker[schoolId+''].hasOwnProperty(schoolId+'')){
                            updateTracker[schoolId+''] = {averageScore:averageScore};
                        }else{
                            updateTracker[schoolId+''].averageScore = averageScore;
                        }
                        setValueFunction(averageScore);
                        setSchoolAverageTracker(updateTracker);
                    }).catch((error) => {
                    console.error('Error loading school average score: ', error);
                });

            }
        }
    }

    // const getAverageClassScore = (classId, callback)=>{
    //     if(testGroupId !== null){
    //         axios.post('/web/ui/test/getClassAverageScore', [], {params: {testGroupId: testGroupId, classId: classId}})
    //         .then(response => {
    //             callback(response.data);
    //         }).catch((error) => {
    //             console.error('Error loading class average score: ', error);
    //         });
    //     }
    // }

    // const getAverageClassGrowth = (classId, callback)=>{
    //     if(testGroupId !== null){
    //         axios.post('/web/ui/test/getClassAverageGrowth', [], {params: {testGroupId: testGroupId, classId: classId}})
    //             .then(response => {
    //                 callback(response.data);
    //             }).catch((error) => {
    //             console.error('Error loading class average score: ', error);
    //         });
    //     }
    // }

    const getAverageSchoolGrowth = ()=>{
        const schoolId = user.schoolId;
        if(schoolId !== undefined){
            if(schoolAverageTracker.hasOwnProperty(schoolId+'') && schoolAverageTracker[schoolId+''].hasOwnProperty('averageScore')){
                setGrowthLineAggregate(schoolAverageTracker[schoolId+''].averageScore);
            }else{
                axios.post('/web/ui/test/getSchoolAverageGrowth', [], {params: {testGroupId:testGroupId
                        // , schoolId:schoolId
                }})
                    .then(response => {
                        const updateTracker =  {...schoolAverageTracker};
                        const averageGrowth = response.data;
                        setGrowthLineAggregate(averageGrowth)
                        updateTracker[schoolId+''] = {averageGrowth:averageGrowth};
                        if(!updateTracker[schoolId+''].hasOwnProperty(schoolId+'')){
                            updateTracker[schoolId+''] = {averageGrowth:averageGrowth};
                        }else{
                            updateTracker[schoolId+''].averageGrowth = averageGrowth;
                        }
                        setSchoolAverageTracker(updateTracker);
                    }).catch((error) => {
                    console.error('Error loading school average score: ', error);
                });

            }
        }
    }


    return (
        <div id={"testGroupReports"}>
            <div className={'grid-fixed-mask'}>
                <div className={'top-mask'}></div>
                <div className={'border-mask'}></div>
            </div>
            <div className={"reportsFormWrapper"}>
                <CollapsibleCard aligned='left' initExpanded={true} title={'Content'}>
                    <Form
                        name="classDiagnostic"
                        form={classForm}
                        initialValues={{reportViewVal:STANDARD_REPORTS.CLASS_QUESTION_VIEW.val}}
                        autoComplete="off"
                    >
                        {/*<span className={'ch-med-font ch-bold'}>Content</span>*/}
                        <Row>
                            <Col className={"flexRow smallGap flexAlignCentre flex1"}>
                                <div className={"flex"}  style={{justifyContent:'end'}}>
                                    <span style={{minWidth:'134px'}}>Select report type</span>
                                </div>
                                <div className="flex flex1">
                                    <Form.Item style={{marginLeft:0}}
                                               className={'flex1'}
                                               name="reportViewVal">
                                        <Select onChange={handleReportChange}
                                                className={'flex1'}
                                                getPopupContainer={trigger => trigger.parentElement}>
                                            {Object.values(STANDARD_REPORTS).map((report) => {
                                                return <Option key={report.val} value={report.val}>{report.description}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                        <Row align={"bottom"}>
                            <div className={"flexRow smallGap"}>
                                <div><span style={{whiteSpace:'noWrap', marginTop:'16px', minWidth:'130px'}}>Select test family <Tooltip
                                    title={(
                                        <div><p>Reports can only be generated for diagnostic tests that have been assigned to a class.</p></div>
                                    )}
                                    placement="top">
                                        <HelpIcon style={{
                                            verticalAlign: 'middle',
                                            marginLeft: '4px',
                                            width: '16px',
                                            height: '16px'
                                        }}/>
                                    </Tooltip></span>
                                </div>
                                <Table
                                    className={'testSelectionTable ch-general-table-antd has-scrollbar'}
                                    size={'small'}
                                    style={{paddingLeft:'8px'}}
                                    // rowHeight={'80px'}
                                    columns={standardTestGroupColumns}
                                    dataSource={testGroupData}
                                    rowSelection={rowSelection}
                                    rowClassName={record => {
                                        if(record.enabled !== undefined && !record.enabled){
                                            return 'table-report-disabled-row';
                                        }else{
                                            return '';
                                        }
                                    }}
                                    loading={isTableLoading}
                                    pagination={{hideOnSinglePage:true}}
                                    scroll={{ y: 140 }}
                                    onRow={(record) => ({
                                        onClick: () => {
                                            //select and de-select row
                                            onRowClick(record);
                                        }
                                    })}
                                />
                            </div>
                        </Row>
                        <Row style={testGroupData.length > 10 ? {marginTop:'-20px'}:{}}>{/*move up when pagination doesn't show*/}
                            <Col className={"flexRow smallGap flexAlignCentre flex1"}>
                                <span style={{minWidth:'134px'}}>Select test/s</span>
                                <div className="flex mediumGap flex1">
                                    <Form.Item style={{ maxWidth: '100%'}}
                                               className={'flex1'}
                                               name="testAssignmentIds">
                                        <Select className={'flex1'} disabled={testAssignments.length === 0} virtual={false} showSearch={false} showarrow={"true"} mode="multiple"
                                                maxTagCount="responsive" allowClear onChange={handleTestAssignments}
                                                getPopupContainer={trigger => trigger.parentElement}>
                                            {testAssignments.map((testAssignment) => {
                                                return <Option key={testAssignment.testAssignmentId}
                                                               value={testAssignment.testAssignmentId}><span className={'flex flexAlignCentre'}>{testAssignment.testName} ( {<Tooltip
                                                    getPopupContainer={trigger => trigger.parentElement.parentElement.parentElement.parentElement }
                                                    title={(
                                                        <div>
                                                            {testAssignment.assignedToStudents ?
                                                                <p>Assigned to students in class</p>
                                                                :
                                                                <p>Assigned to classes</p>}
                                                        </div>
                                                    )}
                                                    placement="top">
                                                    {testAssignment.assignedToStudents ?
                                                        <PeopleIcon fontSize={'small'}/> :
                                                        <ClassIcon fontSize={'small'}/>}
                                                </Tooltip>}
                                                    {testAssignment.classes && <><span style={{marginRight:'4px'}}>,</span>
                                                        {/*<Popover getPopupContainer={trigger => trigger.parentElement.parentElement.parentElement.parentElement } title={'Assigned to ' + testAssignment.classes.length + ' ' + (testAssignment.classes.length > 1 ?'classes':'class')} content={*/}
                                                        {/*    testAssignment.classes.map((clazz)=>{*/}
                                                        {/*return <div>{clazz.className}</div>*/}
                                                    {/*})} trigger="hover">*/}
                                                        <span
                                                            // className={'ch-link'}
                                                            // style={{textDecoration:'underline'}}
                                                        >{testAssignment.classes.length + ' ' + (testAssignment.classes.length > 1 ?'classes':'class')}</span>
                                                        {/*</Popover>*/}
                                                    </>
                                                    }
                                                    {testAssignment.assignedToStudents ? <span style={{marginRight:'4px'}}>, </span>:<></>}{testAssignment.studentNames &&
                                                    //     <Popover getPopupContainer={trigger => trigger.parentElement.parentElement.parentElement.parentElement } title={'Assigned to ' + testAssignment.studentIds.length + ' ' + (testAssignment.studentIds.length > 1 ?'students':'student')} content={testAssignment.studentNames.split(',').map((studentName, index)=>{
                                                    //     return <div >{studentName}</div>
                                                    // })} trigger="hover">
                                                            <span
                                                                // className={'ch-link'}
                                                                //   style={{textDecoration:'underline'}}
                                                            >{testAssignment.studentIds.length + ' ' + (testAssignment.studentIds.length > 1 ?'students':'student')}</span>
                                                    // </Popover>
                                                    }<span style={{marginRight:'4px'}}>,</span>{user.dateTimeMinuteFormat.format(testAssignment.assignedDate)} )</span>
                                            </Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={"flexRow smallGap"}>
                                <span style={{minWidth:'134px'}}/>
                                <div style={{width:'100%'}} className={'flexCentre'}>
                                    <Button size={BUTTON_SIZE.MEDIUM} disabled={(selectedRowKeys.length === 0 || tempTestAssignmentIds.length === 0 || isLoading)}
                                            onClick={generateStandardReport}>Generate</Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </CollapsibleCard>
                <CollapsibleCard aligned='left' parentExpand={refineExpanded} title={'Refine'}>
                    <Form
                        name="contentSearchForm"
                        form={reportForm}
                        size="small"
                        autoComplete="off"
                        initialValues={{classIds: initialClassIds, studentIds: initialStudentIds, diagnosticTests: []}}
                        // onFinish={handleSearch}
                        layout="vertical"
                        style={{width:"100%"}}
                    >
                        <div className={"flexRow mediumGap"}>
                            <div className={"flexColumn flex2"}>
                                <span className={"ch-bold"}>Filter</span>
                                <div className={"flexMax largeGap flexAlignCentre"}>
                                    <div className="flexRow flexAlignCenter mediumGap flex1">
                                        <span>Classes</span>
                                        <Form.Item
                                            // label="Classes"
                                            name="classIds"
                                            className={"flex1"}
                                        >
                                            <Select style={{width:'100%'}} disabled={refineDisabled} virtual={false} showSearch={false} showarrow={"true"} popupRender={menu => (
                                                <div>
                                                    {menu}
                                                    <Divider style={{margin: '0 0 4px 0'}}/>
                                                    <div style={{padding: '4px'}}>
                                                        <Checkbox value={classIds}
                                                                  defaultChecked={true}
                                                                  checked={classIds.length === initialClassIds.length}
                                                                  onChange={handleSelectAllClassesChange}>Select all classes</Checkbox>
                                                    </div>
                                                </div>
                                            )} allowClear autoClearSearchValue={true}
                                                // onSelect={handleStudentSelect} onDeselect={handleStudentDeselect}
                                                    onChange={handleClassChange}
                                                    onClear={handleClassClear}
                                                    mode="multiple" maxTagCount="responsive"
                                                    getPopupContainer={trigger => trigger.parentElement}>
                                                {classes.map((clazz) => {
                                                    return <Option key={clazz.classId}
                                                                   value={clazz.classId}>{clazz.className}</Option>;
                                                })}
                                            </Select>

                                        </Form.Item>
                                    </div>
                                    <div className="flexRow flexAlignCenter mediumGap flex1">
                                        <span>Students</span>
                                        <Form.Item
                                            // label="Students"
                                            name="studentIds"
                                            className={"flex1"}
                                        >
                                            <Select style={{width:'100%'}} disabled={refineDisabled} virtual={false} showSearch={false} showarrow={"true"} popupRender={menu => (
                                                <div>
                                                    {menu}
                                                    <Divider style={{margin: '0 0 4px 0'}}/>
                                                    <div style={{padding: '4px'}}>
                                                        <Checkbox value={studentIds}
                                                                  defaultChecked={true}
                                                                  disabled={studentIds.length === 0 && initialStudentIds.length === 0}
                                                                  checked={studentIds.length === initialStudentIds.length}
                                                                  onChange={handleSelectAllStudentsChange}>Select all students</Checkbox>
                                                    </div>
                                                </div>
                                            )} allowClear autoClearSearchValue={true}
                                                // onSelect={handleStudentSelect} onDeselect={handleStudentDeselect}
                                                    onChange={handleStudentChange}
                                                // onClear={handleStudentClear}
                                                    mode="multiple" maxTagCount="responsive"
                                                    getPopupContainer={trigger => trigger.parentElement}>
                                                {students.map((student) => {
                                                    return <Option key={student.userId}
                                                                   value={student.userId}>{student.lastName + ', ' + student.firstName}</Option>;
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                    {(selectedReportType.val === STANDARD_REPORTS.CLASS_QUESTION_VIEW.val || selectedReportType.val === STANDARD_REPORTS.GROUP_BY_VIEW.val || selectedReportType.val === STANDARD_REPORTS.COMPARISON_VIEW.val) &&
                                        <div className="flexRow flexAlignCenter mediumGap flex1">
                                            <span>Difficulty</span>
                                            <Form.Item
                                                // label="Difficulty"
                                                name="difficulty"
                                                style={{width:'100%'}}
                                                className={"flex1"}
                                            >
                                                <Select style={{width:'210px'}} disabled={refineDisabled} showSearch={false} showarrow={"true"} allowClear mode="multiple"
                                                        onChange={handleDifficultyChange}
                                                        getPopupContainer={trigger => trigger.parentElement}>
                                                    {brandConfig.diagnosticTestLevels.map((level) => {
                                                        return <Option key={level} value={level}>{level}</Option>
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    }
                                </div>
                            </div>
                            {selectedReportType.val === STANDARD_REPORTS.STUDENT_PERFORMANCE_VIEW.val &&
                                <div className={"flexColumn flex1"}>
                                    <span className={"ch-bold"}>Order by</span>
                                    <div className={"flexRow mediumGap"}>
                                        <span>Students</span>
                                        <Form.Item
                                            // label="Students"
                                            name="performanceOrderBy"
                                            style={{width: '95%'}}
                                        >

                                            <Select disabled={refineDisabled} showSearch={false} onChange={handlePerformanceOrderByChange} showarrow={"true"}
                                                    getPopupContainer={trigger => trigger.parentElement}>
                                                {Object.values(PERFORMANCE_ORDER).map((order) => {
                                                    return <Option key={order.val} value={order.val}>{order.description}</Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>}
                        </div>
                    </Form>
                    <Form
                        // className="inlineForm"
                        name="classDiagnosticFilterForm"
                        // form={classFilterForm}
                        layout="vertical"
                        size="small"
                        initialValues={{ columnOrderBy: GRID_ENUMS.NAME_ASC, growthFilterBy: GROWTH_FILTER.ALL.val, scoreFilterBy: TIME_FILTER.ALL.val,
                            aggregateGroupBy: AGGREGATE_LEVELS.SKILL, contentType: GRID_ENUMS.TEXT, contentFilterType:COMPARISON_TYPE.TEXT.val,
                            growthLineAggregate: LOCATION_AGGREGATE.SELECTION.val, scoreLineAggregate: LOCATION_AGGREGATE.SELECTION.val,
                            timeTakenLineAggregate: LOCATION_AGGREGATE.SELECTION.val, timeScoreLineAggregate: LOCATION_AGGREGATE.SELECTION.val,
                            performanceOrderBy: PERFORMANCE_ORDER.ALPHABETICAL.val}}
                        autoComplete="off"

                    >
                        <Row span={24} className={"padding-t--m"}>
                            {(selectedReportType.val === STANDARD_REPORTS.SCORE_VS_TIME_VIEW.val
                                    || selectedReportType.val === STANDARD_REPORTS.GROWTH_VS_ATTAINMENT_VIEW.val) &&
                                <div className={"flexColumn flex2"}>
                                    <div className={"ch-bold"}>Order by</div>
                                    <Col className={"flex1"}>
                                        {selectedReportType.val === STANDARD_REPORTS.GROWTH_VS_ATTAINMENT_VIEW.val &&
                                            <Form.Item
                                                label="Students"
                                                name="growthFilterBy"
                                                style={{width: '95%'}}
                                            >
                                                <Select showSearch={false} disabled={refineDisabled} onChange={handleStudentGrowthOrderByChange} showarrow={"true"}
                                                        getPopupContainer={trigger => trigger.parentElement}>
                                                    {Object.values(GROWTH_FILTER).map((report) => {
                                                        return <Option key={report.val} value={report.val}>{report.description}</Option>
                                                    })}
                                                </Select>
                                            </Form.Item>}
                                        {selectedReportType.val === STANDARD_REPORTS.SCORE_VS_TIME_VIEW.val &&
                                            <Form.Item
                                                label="Students"
                                                name="scoreFilterBy"
                                                style={{width: '95%'}}
                                            >
                                                <Select disabled={refineDisabled} showSearch={false} onChange={handleStudentTimeOrderByChange} showarrow={"true"}
                                                        getPopupContainer={trigger => trigger.parentElement}>
                                                    {Object.values(TIME_FILTER).map((report) => {
                                                        return <Option key={report.val} value={report.val}>{report.description}</Option>
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        }
                                        {selectedReportType.val === STANDARD_REPORTS.COMPARISON_VIEW.val &&
                                            <Form.Item
                                                label="Student"
                                                name="columnOrderBy"
                                                style={{width: '95%', flexFlow: 'row'}}
                                            >
                                                <Select
                                                    disabled={refineDisabled}
                                                    onChange={handleStudentColOrderByChange}
                                                    getPopupContainer={trigger => trigger.parentElement}>
                                                    <Option key={GRID_ENUMS.NAME_ASC} value={GRID_ENUMS.NAME_ASC}>first name
                                                        ascending</Option>
                                                    <Option key={GRID_ENUMS.NAME_DESC} value={GRID_ENUMS.NAME_DESC}>first name
                                                        descending</Option>
                                                    <Option key={GRID_ENUMS.LOWEST} value={GRID_ENUMS.LOWEST}>lowest
                                                        performance</Option>
                                                    <Option key={GRID_ENUMS.HIGHEST} value={GRID_ENUMS.HIGHEST}>highest
                                                        performance</Option>
                                                </Select>
                                            </Form.Item>
                                        }
                                    </Col>
                                </div>
                            }
                            {(selectedReportType.val === STANDARD_REPORTS.GROUP_BY_VIEW.val
                                    || selectedReportType.val === STANDARD_REPORTS.STUDENT_PERFORMANCE_VIEW.val
                                    || selectedReportType.val === STANDARD_REPORTS.COMPARISON_VIEW.val) &&
                                <div className={"flexRow largeGap flex1"}>
                                    <div className={"flexColumn flex2"}>
                                    <span className={"ch-bold"}>Aggregate view<Tooltip title={AGGREGATE_VIEW_TOOLTIP} arrow={{ pointAtCenter: true }}>
                                                <HelpIcon style={{
                                                    verticalAlign: 'middle',
                                                    marginLeft: '4px',
                                                    width: '16px',
                                                    height: '16px'
                                                }}/>
                                        </Tooltip>
                                    </span>
                                        <div className={"flex smallGap"}>
                                            <Col className={"flex1"}>
                                                {(selectedReportType.val === STANDARD_REPORTS.GROUP_BY_VIEW.val
                                                        || selectedReportType.val === STANDARD_REPORTS.STUDENT_PERFORMANCE_VIEW.val) &&
                                                    <Form.Item
                                                        name="contentType"
                                                        label="Course type"

                                                        // tooltip={{title:'Filter by course type'}}
                                                    >
                                                        {/*<Radio.Group onChange={handleContentTypeChange} disabled={aggregateDisabled}>*/}
                                                        <Radio.Group style={{width:'95%'}} disabled={refineDisabled} onChange={handleContentTypeChange} >
                                                            <Radio.Button style={{width:'50%',textAlign:'center'}} value={GRID_ENUMS.TEXT}>Text</Radio.Button>
                                                            {/*<Radio.Button disabled={curriculumDisabled} value={GRID_ENUMS.CURRICULUM}>Curriculum</Radio.Button>*/}
                                                            <Radio.Button style={{width:'50%',textAlign:'center'}} value={GRID_ENUMS.CURRICULUM}>{brandConfig.curriculumName}</Radio.Button>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                }
                                                {selectedReportType.val === STANDARD_REPORTS.COMPARISON_VIEW.val &&
                                                    <Form.Item name="contentFilterType" label="Course type"
                                                        // tooltip={{title:'Filter by course type'}}
                                                    >
                                                        {/*<Radio.Group onChange={handleContentTypeChange} disabled={aggregateDisabled}>*/}
                                                        <Radio.Group style={{width:'95%'}} disabled={refineDisabled} onChange={handleTreeSelectContentFilterChange} >
                                                            <Radio.Button style={{width:'50%',textAlign:'center'}} value={COMPARISON_TYPE.TEXT.val}>Text</Radio.Button>
                                                            {/*<Radio.Button disabled={curriculumDisabled} value={GRID_ENUMS.CURRICULUM}>Curriculum</Radio.Button>*/}
                                                            <Radio.Button style={{width:'50%',textAlign:'center'}} value={COMPARISON_TYPE.CURRICULUM.val}>{brandConfig.curriculumName}</Radio.Button>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                }
                                            </Col>
                                            {(selectedReportType.val === STANDARD_REPORTS.GROUP_BY_VIEW.val
                                                    || selectedReportType.val === STANDARD_REPORTS.STUDENT_PERFORMANCE_VIEW.val) &&
                                                <Col className={"flex1"}>
                                                    <Form.Item
                                                        name="aggregateGroupBy"
                                                        label="Group by"
                                                        style={{width:'100%'}}
                                                    >
                                                        <Select disabled={refineDisabled}
                                                                onChange={handleAggregateLevelChange}
                                                            // disabled={aggregateDisabled}
                                                                style={{minWidth: '150px', marginLeft:'-16px'}}
                                                                getPopupContainer={trigger => trigger.parentElement}>
                                                            {selectedReportType.val === STANDARD_REPORTS.GROUP_BY_VIEW.val &&
                                                                <Option key={AGGREGATE_LEVELS.SYLLABUS}
                                                                        value={AGGREGATE_LEVELS.SYLLABUS}>{contentType === GRID_ENUMS.CURRICULUM ? brandConfig.curriculumName : 'Unit'}</Option>
                                                            }
                                                            <Option key={AGGREGATE_LEVELS.TOPIC}
                                                                    value={AGGREGATE_LEVELS.TOPIC}>{contentType === GRID_ENUMS.CURRICULUM ? brandConfig.curriculumTopicName : brandConfig.topicName}</Option>
                                                            <Option key={AGGREGATE_LEVELS.CONCEPT}
                                                                    value={AGGREGATE_LEVELS.CONCEPT}>{contentType === GRID_ENUMS.CURRICULUM ? brandConfig.curriculumConceptName : brandConfig.conceptName}</Option>
                                                            <Option key={AGGREGATE_LEVELS.SKILL}
                                                                    value={AGGREGATE_LEVELS.SKILL}>{contentType === GRID_ENUMS.CURRICULUM ? brandConfig.curriculumSkillName :'Skill'}</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>}
                                            {selectedReportType.val === STANDARD_REPORTS.COMPARISON_VIEW.val &&
                                                <Col className={"flexRow flex1 smallGap"}>
                                                    {comparisonContentTypeVal === COMPARISON_TYPE.TEXT.val &&
                                                        <>
                                                            <span>Text</span>
                                                            <Form.Item
                                                                // label="Text"
                                                                name="textSelect"
                                                                style={{width:'100%'}}
                                                            >
                                                                <TreeSelectFilter disabled={refineDisabled} triggerGenerate={triggerStandardGenerate} setValues={setTextValues} testIds={selectedTestIds} comparisonContentTypeVal={comparisonContentTypeVal} diagnosticContentType={COMPARISON_TYPE.TEXT.upperDisplay} />
                                                            </Form.Item>
                                                        </>
                                                    }
                                                    {comparisonContentTypeVal === COMPARISON_TYPE.CURRICULUM.val &&
                                                        <>
                                                            <span>{brandConfig.curriculumName}</span>
                                                            <Form.Item
                                                                // label="Curriculum"
                                                                name="curriculumSelect"
                                                                style={{width:'100%'}}
                                                            >
                                                                <TreeSelectFilter disabled={refineDisabled} triggerGenerate={triggerStandardGenerate} setValues={setCurriculumValues} testIds={selectedTestIds} comparisonContentTypeVal={comparisonContentTypeVal} diagnosticContentType={COMPARISON_TYPE.CURRICULUM.upperDisplay} />
                                                            </Form.Item>
                                                        </>
                                                    }
                                                </Col>}

                                        </div>
                                    </div>
                                    {(selectedReportType.val === STANDARD_REPORTS.COMPARISON_VIEW.val) &&
                                        <div className={"flexColumn flex1"}>
                                            <span className={"ch-bold"}>Display</span>
                                            <Row className={"flex largeGap"}>
                                                <Col>
                                                    <Form.Item className="toggleSwitch" label="Trend lines" tooltip={{title:'Trend lines'}}>
                                                        <Switch
                                                            disabled={refineDisabled}
                                                            style={{marginLeft:'6px'}}
                                                            defaultChecked={true}
                                                            onChange={toggleTrendLines}
                                                            color="primary"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Form.Item className="toggleSwitch" label="Average line" tooltip={{title:'Average line'}}>
                                                        <Switch
                                                            disabled={refineDisabled}
                                                            style={{marginLeft:'6px'}}
                                                            defaultChecked={true}
                                                            onChange={toggleAverageLine}
                                                            color="primary"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    }
                                </div>
                            }
                            {(selectedReportType.val === STANDARD_REPORTS.GROWTH_VS_ATTAINMENT_VIEW.val
                                    || selectedReportType.val === STANDARD_REPORTS.STUDENT_PERFORMANCE_VIEW.val) &&
                                <Row>
                                    <Col className={"flex1"}>
                                        <span className={"ch-bold"}>Display</span>
                                        <div className={'flexRow flex1 largeGap'}>
                                            <div className={'flexRow mediumGap'}>
                                                <div>
                                                    <Form.Item className="toggleSwitch" label="Average score line">
                                                        <Switch
                                                            disabled={refineDisabled}
                                                            style={{marginLeft:'6px'}}
                                                            defaultChecked={true}
                                                            onChange={toggleScoreLine}
                                                            color="primary"
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div>
                                                    <Form.Item
                                                        // label=""
                                                        name="scoreLineAggregate"
                                                    >
                                                        <Select style={{minWidth: '81px'}} disabled={refineDisabled} onChange={handleAverageScoreLineGrowth}
                                                                showSearch={false} showarrow={"true"} getPopupContainer={trigger => trigger.parentElement}>
                                                            {Object.values(LOCATION_AGGREGATE).map((report) => {
                                                                return <Option key={report.val} value={report.val}>{report.description}</Option>
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                    {/*{showScoreGrowthClasses &&*/}
                                                    {/*        <Form.Item name="averageScoreLineClass">*/}
                                                    {/*            <Select style={{minWidth:'120px'}} disabled={refineDisabled} virtual={false} showSearch={false} showarrow={"true"} allowClear autoClearSearchValue={true}*/}
                                                    {/*                    onChange={averageScoreGrowthClassChange}*/}
                                                    {/*                    maxTagCount="responsive"*/}
                                                    {/*                    getPopupContainer={trigger => trigger.parentElement}>*/}
                                                    {/*                {classes.map((clazz) => {*/}
                                                    {/*                    return <Option key={clazz.classId}*/}
                                                    {/*                                   value={clazz.classId}>{clazz.className}</Option>;*/}
                                                    {/*                })}*/}
                                                    {/*            </Select>*/}
                                                    {/*        </Form.Item>*/}
                                                    {/*    }*/}
                                                </div>
                                            </div>
                                            {selectedReportType.val === STANDARD_REPORTS.GROWTH_VS_ATTAINMENT_VIEW.val &&
                                                <div className={"flexRow flex3"} style={{gap:'4px'}}>
                                                    <div>
                                                        <Form.Item className="toggleSwitch flexRow" label="Average growth line">
                                                            <Switch
                                                                disabled={refineDisabled}
                                                                style={{marginLeft:'6px'}}
                                                                defaultChecked={true}
                                                                onChange={toggleGrowthLine}
                                                                color="primary"
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div>
                                                        <Form.Item
                                                            name="growthLineAggregate">
                                                            <Select disabled={refineDisabled} style={{minWidth: '81px'}} onChange={handleAverageGrowthLine}
                                                                    showSearch={false} showarrow={"true"} getPopupContainer={trigger => trigger.parentElement}>
                                                                {Object.values(LOCATION_AGGREGATE).map((report) => {
                                                                    return <Option key={report.val} value={report.val}>{report.description}</Option>
                                                                })}
                                                            </Select>
                                                        </Form.Item>
                                                        {/*{showGrowthLineClasses &&*/}
                                                        {/*    <Form.Item name="averageGrowthLineClass">*/}
                                                        {/*        <Select style={{minWidth:'120px'}} disabled={refineDisabled} virtual={false} showSearch={false} showarrow={"true"} allowClear autoClearSearchValue={true}*/}
                                                        {/*                onChange={averageScoreGrowthClassChange}*/}
                                                        {/*                maxTagCount="responsive"*/}
                                                        {/*                getPopupContainer={trigger => trigger.parentElement}>*/}
                                                        {/*            {classes.map((clazz) => {*/}
                                                        {/*                return <Option key={clazz.classId}*/}
                                                        {/*                               value={clazz.classId}>{clazz.className}</Option>;*/}
                                                        {/*            })}*/}
                                                        {/*        </Select>*/}
                                                        {/*    </Form.Item>*/}
                                                        {/*}*/}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            }
                            {selectedReportType.val === STANDARD_REPORTS.SCORE_VS_TIME_VIEW.val &&
                                <>
                                    <Col className={"flex3"}>
                                        <span className={"ch-bold"}>Display</span>
                                        <div className={'flexRow flex1 largeGap'}>
                                            <div className={'flexRow flex1 mediumGap'}>
                                                <div>
                                                    <Form.Item className="toggleSwitch" label="Average score line"
                                                               style={{width:'100%'}}>
                                                        <Switch
                                                            disabled={refineDisabled}
                                                            style={{marginLeft:'6px'}}
                                                            defaultChecked={true}
                                                            onChange={toggleAverageScoreTimeLine}
                                                            color="primary"
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div className={"flex1"}>
                                                    <Form.Item
                                                        // label=""
                                                        name="timeScoreLineAggregate"
                                                    >
                                                        <Select style={{width: '80px'}} onChange={handleAverageScoreLineTime} disabled={refineDisabled}
                                                                showSearch={false} showarrow={"true"} getPopupContainer={trigger => trigger.parentElement}>
                                                            {Object.values(LOCATION_AGGREGATE).map((report) => {
                                                                return <Option key={report.val} value={report.val}>{report.description}</Option>
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                    {/*{showScoreTimeClasses &&*/}
                                                    {/*    <Form.Item name="averageScoreLineClass">*/}
                                                    {/*        <Select style={{minWidth:'120px'}} disabled={initialClassIds.length === 0} virtual={false} showSearch={false} showarrow={"true"} allowClear autoClearSearchValue={true}*/}
                                                    {/*            onChange={(val)=>{averageScoreTimeClassChange(val,setAverageScoreLineTimeReport)}}*/}
                                                    {/*                maxTagCount="responsive"*/}
                                                    {/*                getPopupContainer={trigger => trigger.parentElement}>*/}
                                                    {/*            {classes.map((clazz) => {*/}
                                                    {/*                return <Option key={clazz.classId}*/}
                                                    {/*                               value={clazz.classId}>{clazz.className}</Option>;*/}
                                                    {/*            })}*/}
                                                    {/*        </Select>*/}
                                                    {/*    </Form.Item>*/}
                                                    {/*}*/}
                                                </div>
                                            </div>
                                            <div className={"flexRow flex1"} style={{gap:'4px'}}>
                                                <div>
                                                    <Form.Item className="toggleSwitch flexRow" label="Average time taken line">
                                                        <Switch
                                                            disabled={refineDisabled}
                                                            style={{marginLeft:'6px'}}
                                                            defaultChecked={true}
                                                            onChange={toggleAverageTimeTakenLine}
                                                            color="primary"
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div className={"flex1"}>
                                                    <Form.Item
                                                        disabled={refineDisabled}
                                                        name="timeTakenLineAggregate"
                                                        style={{width: '80px'}}>
                                                        <Select style={{minWidth:'80px'}} onChange={handleTimeTakenAggregateChange} disabled={refineDisabled}
                                                                showSearch={false} showarrow={"true"} getPopupContainer={trigger => trigger.parentElement}>
                                                            {Object.values(LOCATION_AGGREGATE).map((report) => {
                                                                return <Option key={report.val} value={report.val}>{report.description}</Option>
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                    {/*{showTimeTakenClasses &&*/}
                                                    {/*    <Form.Item name="timeTakenLineClass">*/}
                                                    {/*        <Select style={{minWidth:'120px'}} disabled={initialClassIds.length === 0} virtual={false} showSearch={false} showarrow={"true"} allowClear autoClearSearchValue={true}*/}
                                                    {/*                onChange={timeTakenClassChange}*/}
                                                    {/*                maxTagCount="responsive"*/}
                                                    {/*                getPopupContainer={trigger => trigger.parentElement}>*/}
                                                    {/*            {classes.map((clazz) => {*/}
                                                    {/*                return <Option key={clazz.classId}*/}
                                                    {/*                               value={clazz.classId}>{clazz.className}</Option>;*/}
                                                    {/*            })}*/}
                                                    {/*        </Select>*/}
                                                    {/*    </Form.Item>*/}
                                                    {/*}*/}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    </Form>
                </CollapsibleCard>
            </div>
            <div style={{
                borderBottom:'1px solid lightgrey'
            }}></div>
            <div id="graphView" className={'margin-t--l'}>
                <CircularLoader displayInElement={true} pageCentered={true} visible={isLoading} />
                {!isLoading &&
                    <>
                        {feedbackMessage !== undefined &&
                            <p className={'ch-dashboard-warning-text'}>{feedbackMessage}</p>
                        }
                        {studentIds.length > 0 && testAssignmentResultsData !== undefined && dataHasResults &&
                            <>
                                <h3 dangerouslySetInnerHTML={{__html: reportTitle}}/>
                                {warningFeedbackMessage !== undefined &&
                                    <p className={'ch-dashboard-warning-text'}>{warningFeedbackMessage}</p>}
                                <div>
                                    {selectedReportType.val === STANDARD_REPORTS.CLASS_QUESTION_VIEW.val &&
                                        <ClassQuestionViewDiagnosticV2
                                            isDiagnostic={false}
                                            testAssignmentsData={testAssignmentResultsData}
                                            studentTestAssignmentsMap={studentTestAssignmentsMap}
                                            questionCount={questionCount}
                                            students={students}
                                            studentIds={studentIds}
                                            // classId={classId}
                                            className={className}
                                            studentColOrder={studentColOrder}
                                            initialDifficultyIds={initialDifficultyIds}
                                            selectedDifficultyIds={selectedDifficultyIds}
                                            selectedTestIds={selectedTestIds}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            feedbackMessage={feedbackMessage}
                                            headerHeightOffset={headerHeightOffset}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                        />
                                    }
                                    {selectedReportType.val === STANDARD_REPORTS.GROUP_BY_VIEW.val &&
                                        <GroupByAggregateViewV2
                                            isDiagnostic={false}
                                            testAssignmentsData={testAssignmentResultsData}
                                            students={students}
                                            studentIds={studentIds}
                                            className={className}
                                            studentColOrder={studentColOrder}
                                            selectedAggregateLevel={selectedAggregateLevel}
                                            headerAmount={aggregateHeaderAmount}
                                            selectedDifficultyIds={selectedDifficultyIds}
                                            selectedTestIds={[testId]}
                                            contentType={contentType}
                                            testAssignmentType={GRID_ENUMS.EXAM}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            headerHeightOffset={headerHeightOffset}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                        />
                                    }
                                    {selectedReportType.val === STANDARD_REPORTS.COMPARISON_VIEW.val &&
                                        <ComparisonView
                                            testAssignmentsData={testAssignmentResultsData}
                                            students={students}
                                            studentIds={studentIds}
                                            useContentFilters={false}
                                            isTestGroup={true}
                                            selectedDifficultyIds={selectedDifficultyIds}
                                            selectedTestIds={selectedTestIds}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            showTrendLines={showTrendLines}
                                            showAverageLine={showAverageLine}
                                            comparisonContentTypeVal={comparisonContentTypeVal}
                                            curriculumValues={curriculumValues}
                                            textValues={textValues}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                        />
                                    }
                                    {selectedReportType.val === STANDARD_REPORTS.STUDENT_PERFORMANCE_VIEW.val &&
                                        <StudentPerformanceView
                                            testAssignmentsData={testAssignmentResultsData}
                                            students={students}
                                            studentIds={studentIds}
                                            classIds={classIds}
                                            initialClassIds={initialClassIds}
                                            schoolId={user.schoolId}
                                            averageScoreTypeGrowthSelected={averageScoreTypeGrowthSelected}
                                            useContentFilters={false}
                                            performanceOrderBy={performanceOrderBy}
                                            selectedAggregateLevel={selectedAggregateLevel}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            contentType={contentType}
                                            showAverageScoreLine={showAverageScoreLine}
                                            curriculumValues={curriculumValues}
                                            textValues={textValues}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                        />
                                    }
                                    {selectedReportType.val === STANDARD_REPORTS.SCORE_VS_TIME_VIEW.val &&
                                        <ScoreVsTimeView
                                            testAssignmentsData={testAssignmentResultsData}
                                            students={students}
                                            studentIds={studentIds}
                                            selectedTestIds={selectedTestIds}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            showTimeLine={showAverageTimeTakenLine}
                                            showScoreLine={showAverageScoreTimeLine}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                            studentTimeFilter={studentTimeFilter}
                                            timeTakenAggregate={timeTakenLineAggregate}
                                            timeTakenSelect={timeTakenTypeSelected}
                                            averageScoreSelect={averageScoreTypeSelected}
                                            scoreAverageAggregate={averageScoreLineTimeReport}
                                        />
                                    }
                                    {selectedReportType.val === STANDARD_REPORTS.GROWTH_VS_ATTAINMENT_VIEW.val &&
                                        <GrowthVsAttainment
                                            testAssignmentsData={testAssignmentResultsData}
                                            students={students}
                                            studentIds={studentIds}
                                            selectedTestIds={selectedTestIds}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            showGrowthLine={showGrowthLine}
                                            showAverageScoreLine={showAverageScoreLine}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                            studentGrowthFilter={studentGrowthFilter}
                                            scoreAverageAggregate={averageScoreLineGrowthReport}
                                            growthAggregate={growthLineAggregate}
                                            growthSelect={growthTypeSelected}
                                            averageScoreSelect={averageScoreTypeGrowthSelected}
                                        />
                                    }
                                </div>
                            </>
                        }
                    </>
                }
                <StudentTestResultDialog open={studentTestResultDialogOpen} testAssignmentIds={userTestAssignmentIds} studentId={studentId} handleClose={handleCloseStudentTestsDialog} />
            </div>
        </div>
    );
}
export default TestGroupReports;
